import React from "react";
import legalDocs from "./info.json";

const Docs = ({ currentDoc, onClose }) => {
  if (!currentDoc) return null; // nothing to show if null

  const doc = legalDocs[currentDoc];

  return (
    <div className='overlay'>
      <div className='doc-cont'>
        <button onClick={onClose}>Close</button>
        <div className='doc-text'>
          <h2>{currentDoc}</h2>
          <p>{doc.introduction}</p>
          {doc.sections.map((section, idx) => (
            <div key={idx}>
              <h3>{section.title}</h3>
              {section.content.map((item, index) => (
                <p key={index}>{item}</p>
              ))}
              {section.contact && (
                <div>
                  {section.contact.company && <p>{section.contact.company}</p>}
                  {section.contact.phone && <p>Phone: {section.contact.phone}</p>}
                  {section.contact.email && (
                    <p>Email: <a href={`mailto:${section.contact.email}`}>{section.contact.email}</a></p>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Docs;
